<template>
  <el-dialog :visible="show" width="75%" @drop="dropHandler" @close="closeModal">
    <ModalHeader slot="title" icon="fas fa-upload" title="Kiểm tra tài liệu mới" />
    <vue-dropzone
      :ref="refs.DROP_ZONE"
      id="dropzone"
      :options="dropzoneOptions"
      @vdropzone-mounted="onDropzoneMounted"
      @vdropzone-file-added="onFileAdded"
      @vdropzone-removed-file="onFileRemove"
    />
    <br />
    <el-form ref="formPlagiarism" label-width="160px" v-if="isFileExist" :rules="rules" :model="form">
      <el-form-item label="Tiêu đề" prop="title">
        <el-input placeholder="Tiêu đề tài liệu" name="title" v-model="form.title" maxlength="200" />
      </el-form-item>
      <el-form-item label="Họ và tên tác giả" prop="author">
        <el-col :span="24">
          <el-input placeholder="Họ và tên tác giả" name="author" v-model="form.author"></el-input>
        </el-col>
      </el-form-item>

      <el-form-item label="Trang kiểm tra">
        <el-col :span="24" class="checker-type-container">
          <el-radio label="all" v-model="form.mode_page_check" border class="checker-type">Kiểm tra toàn bộ</el-radio>
          <el-radio label="part" border v-model="form.mode_page_check" class="checker-type">Kiểm tra một phần</el-radio>

          <transition name="fade">
            <el-input placeholder="1-5, 8, 11-13" v-model="form.pages" v-if="form.mode_page_check === 'part'">
              <template slot="prepend">Trang kiểm tra</template>
            </el-input>
          </transition>
        </el-col>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal">Hủy bỏ</el-button>
      <CommonButton
        :ref="refs.SUBMIT_BUTTON"
        type="primary"
        :disabled="disableButton"
        @click="onSubmitCreateDocumentForm"
      >
        Kiểm tra tài liệu
      </CommonButton>
    </span>
  </el-dialog>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { apiCreateDocument } from '@/services/document_management_service'
import { maxFileUpload } from '@/constants/DoITConstant'
import FAIcon from '@/components/common/FAIcon.vue'
import { mapState } from 'vuex'
import { AUTHENTICATE_STORE } from '@/store/modules/AuthenticateStore'
import ModalHeader from '@/components/common/ModalHeader.vue'
import CommonButton from '@/components/common/CommonButton.vue'

const TITLE_MAX_LENGTH = 200
const AUTHOR_MAX_LENGTH = 100
const MAX_FILE_SIZE_IN_MB = 20

export default {
  name: 'DocumentCreate',
  components: {
    CommonButton,
    ModalHeader,
    vueDropzone: vue2Dropzone,
    FAIcon,
  },
  props: ['listDroppedFiles'],
  data: function () {
    return {
      show: false,
      fileList: [],
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        autoProcessQueue: false,
        thumbnailWidth: 150,
        maxFilesize: MAX_FILE_SIZE_IN_MB,
        maxFiles: maxFileUpload.DocumentCreate,
        addRemoveLinks: true,
        dictRemoveFile: 'Loại bỏ',
        dictInvalidFileType: 'Sai định dạng file',
        dictMaxFilesExceeded: '',
        dictDefaultMessage:
          '<h4>Kéo thả tài liệu hoặc bấm đây</h4>' +
          '<br/>Các định dạng file được hỗ trợ: <b>doc, docx, pdf</b>' +
          `<br/>Dung lượng file không quá <b>${MAX_FILE_SIZE_IN_MB}MB</b>, số lượng trang <b> không quá 300 trang.</b>` +
          `<br/>Với tài liệu lớn hơn, xin vui lòng chia nhỏ thành nhiều phần và kiểm tra riêng từng phần. ` +
          `<br/>Việc nén hoặc thu nhỏ kích thước font chữ để giảm số trang có thể khiến tài liệu không xử lý được,`,
        acceptedFiles: '.doc, .docx, .pdf',
      },
      form: {
        title: '',
        author: '',
        pages: '',
        mode_page_check: 'all',
      },
      isFileExist: false,
      fileInProcess: 0,
      refs: {
        SUBMIT_BUTTON: 'SUBMIT_BUTTON',
        DROP_ZONE: 'DROP_ZONE',
      },
      rules: {
        title: [
          { required: true, message: 'Hãy nhập tiêu đề tài liệu', trigger: 'blur' },
          {
            min: 1,
            max: TITLE_MAX_LENGTH,
            message: `Độ dài tiêu đề trong khoảng 1 đến ${TITLE_MAX_LENGTH} ký tự`,
            trigger: 'blur',
          },
        ],
        author: [
          { required: true, message: 'Hãy nhập họ tên tác giả', trigger: 'blur' },
          {
            min: 1,
            max: AUTHOR_MAX_LENGTH,
            message: `Độ dài họ tên tác giả trong khoảng 1 đến ${AUTHOR_MAX_LENGTH} ký tự`,
            trigger: 'blur',
          },
        ],
      },
      TITLE_MAX_LENGTH,
      AUTHOR_MAX_LENGTH,
    }
  },
  methods: {
    openModal() {
      this.show = true
    },
    closeModal() {
      this.show = false
      this.$refs[this.refs.DROP_ZONE].removeAllFiles()
    },
    onDropzoneMounted() {
      this.manuallyAddFile()
    },
    async onSubmitCreateDocumentForm() {
      const acceptedFiles = this.$refs[this.refs.DROP_ZONE].getAcceptedFiles()
      if (this.form.mode_page_check === 'all' || acceptedFiles.length > 1) {
        this.form.pages = null
      }
      let title = this.form.title
      let pages = this.form.pages
      let author = this.form.author
      if (acceptedFiles.length > 0) {
        let failDocs = []
        const loading = this.$loading({ text: 'Đang gửi tài liệu' })

        for (let file of acceptedFiles) {
          await apiCreateDocument(file, title, pages, author, (ex) => {
            failDocs.push(file.name)
          })
        }
        if (failDocs.length === 0) {
          this.$message.success('Thành công')
          this.$emit('success')
        } else {
          failDocs.forEach((title) => {
            this.$message.error('Lỗi tải lên: ' + title)
          })
        }

        this.show = false
        this.$refs[this.refs.DROP_ZONE].removeAllFiles()
        loading.close()
      } else {
        this.$message.error('Tài liệu tải lên không đúng định dạng')
      }
    },
    onFileAdded(file) {
      this.fileInProcess += 1
      if (this.fileInProcess > maxFileUpload.DocumentCreate) {
        this.$refs[this.refs.DROP_ZONE].removeFile(file)
        this.$message.error('Số tài liệu đã vượt quá số lượng quy định (không quá 5)')
      } else {
        let file_extension = file.name.split('.').slice(-1)[0]
        if (file_extension === 'zip') {
          this.form.title = ''
        } else {
          this.form.title = file.name.split('.').slice(0, -1).join('.')
        }
        this.form.author = this.user.name
        this.isFileExist = this.$refs[this.refs.DROP_ZONE].dropzone.files.length > 0
      }
    },
    onFileRemove(file) {
      this.isFileExist = this.$refs[this.refs.DROP_ZONE].dropzone.files.length > 0
      this.fileInProcess -= 1
    },
    dropHandler(e) {
      e.preventDefault()
      e.stopPropagation()
    },
    manuallyAddFile() {
      if (this.$refs[this.refs.DROP_ZONE]) {
        for (let i = 0; i < this.listDroppedFiles.length; i++) {
          if (this.fileInProcess < maxFileUpload.DocumentCreate) {
            let fileType = this.listDroppedFiles[i].name.split('.').slice(-1)[0]
            let isAccepted = fileType === 'doc' || fileType === 'docx' || fileType === 'pdf' || fileType === 'zip'
            this.listDroppedFiles[i].accepted = isAccepted
            this.$refs.myVueDropzone.manuallyAddFile(this.listDroppedFiles[i], '', null, null, {
              dontSubstractMaxFiles: false,
              addToFiles: true,
            })
          }
        }
        this.$emit('removeAllFileInDroppedList')
      }
    },
  },
  computed: {
    ...mapState({
      user: (state) => state[AUTHENTICATE_STORE].user,
    }),
    disableButton() {
      return (
        !this.isFileExist ||
        !this.form.title ||
        this.form.title.length === 0 ||
        !this.form.author ||
        this.form.author.length === 0
      )
    },
  },
  watch: {
    listDroppedFiles: function () {
      if (this.listDroppedFiles.length > 0) {
        this.show = true
        this.manuallyAddFile()
      }
    },
    show: function () {
      if (!this.show) {
        this.$refs[this.refs.DROP_ZONE].removeAllFiles()
        this.fileInProcess = 0
      }
    },
  },
}
</script>

<style>
.checker-type-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: hidden;
}

.checker-type {
  width: 180px;
  margin-right: 10px;
}

.el-form-item__content .checker-type-container {
  margin: 0 0 8px 0;
  color: #8d9094;
  width: calc(100% - 180px - 10px);
  min-width: 260px;
}

.vue-dropzone .dz-preview .dz-remove {
  border: none;
  width: 100%;
  height: 100%;
  text-align: center;
  top: 0;
  left: 0;
  margin: 0;
  background-color: rgba(108, 117, 125, 0.8);
  padding: 38% 10%;
}

.vue-dropzone .dz-preview .dz-error-mark {
  display: none;
}

.vue-dropzone .dz-preview.dz-error .dz-remove {
  padding-top: 70%;
  padding-bottom: 0;
}

.vue-dropzone > .dz-preview .dz-image {
  height: 120px;
}

.el-form-item__content .el-input-group {
  margin-top: 10px;
}
</style>
